import Select from './select/ContractAgreementDetailSelect';
import Text from './text/ContractAgreementDetailText'

export default { Select, Text };
